<template>
  <div class="flex flex-col gap-6">
    <!-- Step 1: Script Tag -->
    <div>
      <h3 class="text-lg font-semibold mb-4 flex items-center gap-2">
        <span class="bg-cyan-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm">1</span>
        {{ $t('botEditor.deploy.step1Title') }}
      </h3>
      <p class="text-gray-400 text-sm mb-3">
        {{ $t('botEditor.deploy.step1Description') }}
      </p>
      <div class="bg-gray-900 border border-gray-700 rounded-lg p-4 font-mono text-sm">
        <code class="text-gray-300 break-words">
          &lt;script src="{{ apiBaseUrl }}/api/v1/bots/{{ productionBotId }}/widget.js"&gt;&lt;/script&gt;
        </code>
      </div>
      <Button id="btn-copy-script-tag" severity="primary" class="mt-3" @click="copyToClipboard">
        <span class="material-icons">content_copy</span>
        {{ copySuccess ? $t('botEditor.deploy.copied') : $t('botEditor.deploy.copyButton') }}
      </Button>
    </div>

    <!-- Step 2: Widget Placement -->
    <div>
      <h3 class="text-lg font-semibold mb-4 flex items-center gap-2">
        <span class="bg-cyan-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm">2</span>
        {{ $t('botEditor.deploy.step2Title') }}
      </h3>
      <p class="text-gray-400 text-sm">
        {{ $t('botEditor.deploy.step2Description') }}
      </p>
    </div>

    <!-- Info Box -->
    <div class="bg-blue-900/30 border border-blue-700/50 rounded-lg p-4">
      <p class="text-blue-300 text-sm">
        <strong>💡 {{ $t('botEditor.deploy.infoTitle') }}</strong>
        <br />
        {{ $t('botEditor.deploy.infoDescription') }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import api from '../../services/api';

const route = useRoute();
const botId = computed(() => route.params.id);
const workspaceId = computed(() => route.params.workspaceId);

const copySuccess = ref(false);
const bot = ref(null);

const apiBaseUrl = computed(() => {
  return import.meta.env.VITE_APP_API_URL || window.location.origin;
});

// Usa il bot di produzione se esiste, altrimenti usa il test bot
const productionBotId = computed(() => {
  if (bot.value && bot.value.productionBotId) {
    return bot.value.productionBotId;
  }
  return botId.value;
});

onMounted(async () => {
  await fetchBotDetails();
});

const fetchBotDetails = async () => {
  try {
    const response = await api.get(`/workspaces/${workspaceId.value}/bots/${botId.value}`);
    bot.value = response.data.data;
  } catch (error) {
    Console.error('Error fetching bot details:', error);
  }
};

const copyToClipboard = async () => {
  const scriptTag = `<script src="${apiBaseUrl.value}/api/v1/bots/${productionBotId.value}/widget.js"><\/script>`;
  try {
    await navigator.clipboard.writeText(scriptTag);
    copySuccess.value = true;
    setTimeout(() => {
      copySuccess.value = false;
    }, 2000);
  } catch (error) {
    Console.error('Failed to copy:', error);
  }
};
</script>
